<script setup lang="ts">
import { computed } from "vue";

export interface TcRangeProps {
  label: string;
  max: string;
  percentage: number;
  value: string;
}

const props = defineProps<TcRangeProps>();
const percentageUi = computed((): string => `${props.percentage}%`);
</script>

<template>
  <section class="tc-range">
    <div class="info">
      <p class="label">{{ label }}</p>
      <p class="values">{{ `${value}/${max}` }}</p>
    </div>

    <div class="range-background">
      <div class="range-foreground" :style="{ width: percentageUi }" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
$tsRangeHeight: 0.5rem;

.tc-range {
  .info {
    display: flex;

    .label {
      @include text.general(low, l);
      @include colors.color(content, high);

      flex-grow: 1;
    }

    .values {
      @include text.general(low, l);
      @include colors.color(content, mid);
    }
  }

  .range-background {
    @include radius(m);
    @include sp.margin(t, 2);
    @include colors.bg(content, low);

    position: relative;
    height: $tsRangeHeight;
    width: 100%;

    .range-foreground {
      @include colors.bg(content, high);
      @include radius(m);

      position: absolute;
      height: $tsRangeHeight;
      left: 0;
      top: 0;
    }
  }
}
</style>
